import React, { forwardRef } from 'react'
import { SnackbarContentProps, useSnackbar } from 'notistack'
import tw from 'twin.macro'
import {
  CircleTickMajor,
  CircleCancelMajor,
  CircleAlertMajor,
  MobileCancelMajor,
} from '@shopify/polaris-icons'
import { IconButton } from '@mui/material'

export interface CustomSnackbarContentProps extends SnackbarContentProps {
  message: React.ReactNode
  variant?: 'success' | 'error' | 'warning'
}

const variantConfig = {
  success: { icon: CircleTickMajor, style: tw`fill-success-500` },
  error: { icon: CircleCancelMajor, style: tw`fill-critical-500` },
  warning: { icon: CircleAlertMajor, style: tw`fill-warning-500` },
}

export const CustomSnackbarContent = forwardRef<HTMLDivElement, CustomSnackbarContentProps>(
  ({ message, variant, id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar()
    const config = variant && variantConfig[variant]
    const Icon = config?.icon

    const handleClose = () => {
      if (id) {
        closeSnackbar(id)
      }
    }

    return (
      <div
        ref={ref}
        {...props}
        css={tw`bg-black px-4 py-2 rounded-lg flex items-center justify-between text-base text-shades-0`}
      >
        <div css={tw`flex items-center`}>
          {Icon && <Icon width={20} height={20} css={[tw`flex-shrink-0 mr-4`, config.style]} />}
          <div>{message}</div>
        </div>
        <IconButton onClick={handleClose} size="small" sx={{ ml: 2 }}>
          <MobileCancelMajor width={20} height={20} css={tw`fill-shades-0`} />
        </IconButton>
      </div>
    )
  },
)
